export const favoritesKeys = {
  all: ['favorites'] as const,

  ids: (userId?: string | null) =>
    [...favoritesKeys.all, 'ids', userId ?? null] as const,

  welcome: (userId?: string | null) =>
    [...favoritesKeys.all, 'welcome', userId ?? null] as const,

  list: (userId?: string | null) =>
    [...favoritesKeys.all, 'list', userId ?? null] as const,
};